<div class="edit-env-wrapper">
  <!-- <h2>Modify Environment</h2> -->
  <app-environment-form
    [mode]="'edit'"
    [environment]="environment"
    (formSubmitted)="handleFormSubmit($event)"
    (cancel)="closeEdit()">
  </app-environment-form>
</div> 
